function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "HOME-07",
  transform: "translate(-732.000000, -633.000000)",
  stroke: "#fff",
  strokeWidth: 4
}, React.createElement("path", {
  d: "M787.340359,690.340359 L747.59244,690.340359 C728.014318,690.340359 712.141012,674.453646 712.141012,654.858988",
  id: "Stroke-1",
  transform: "translate(749.740685, 672.599673) scale(-1, 1) rotate(-270.000000) translate(-749.740685, -672.599673) "
}), React.createElement("polyline", {
  id: "Stroke-3",
  transform: "translate(767.479998, 697.782433) scale(-1, 1) rotate(-270.000000) translate(-767.479998, -697.782433) ",
  points: "755.062692 722.639 779.897304 697.783413 755.062692 672.925865"
})));

var SvgArrowSlider = function SvgArrowSlider(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "62px",
    height: "80px",
    viewBox: "0 0 62 80",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowSlider, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrowSlider.7ef70072.svg";
export { ForwardRef as ReactComponent };